import { render, staticRenderFns } from "./DebugV2.vue?vue&type=template&id=61578fa2&scoped=true"
import script from "./DebugV2.vue?vue&type=script&lang=js"
export * from "./DebugV2.vue?vue&type=script&lang=js"
import style0 from "./DebugV2.vue?vue&type=style&index=0&id=61578fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61578fa2",
  null
  
)

export default component.exports